import React, { useEffect, useState } from 'react';

/**
 * Renders a File/Blob or a string URL. Object URLs are revoked on change and unmount
 * so previews do not accumulate blob entries for the life of the page.
 */
export default function BlobPreview({ file, alt = '', className = '', ...rest }) {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    if (!(file instanceof Blob)) {
      setObjectUrl('');
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setObjectUrl(url);
    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  const src = typeof file === 'string' ? file : objectUrl;
  if (!src) return null;
  return <img src={src} alt={alt} className={className} {...rest} />;
}
